import { render, staticRenderFns } from "./compatibleFile.vue?vue&type=template&id=193cbf56&scoped=true"
import script from "./compatibleFile.vue?vue&type=script&lang=js"
export * from "./compatibleFile.vue?vue&type=script&lang=js"
import style0 from "./compatibleFile.vue?vue&type=style&index=0&id=193cbf56&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193cbf56",
  null
  
)

export default component.exports